import React from 'react';
import { AvatarGroup as ChakraAvatarGroup } from '@chakra-ui/react';

export interface AvatarGroupProps {
  max?: number;
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({ children, max }) => {
  return (
    <ChakraAvatarGroup max={max} size="sm">
      {children}
    </ChakraAvatarGroup>
  );
};

AvatarGroup.defaultProps = {};

export default AvatarGroup;
